import { createHashHistory } from 'history';

// Create the history object here to make the history accessible
// outside of the React Router children components
export const history = createHashHistory();
